import styled from 'styled-components';

const RightShadowBorder = styled.div`
  &::after {
    content: '';
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) calc(100% - 0.5rem),
      rgba(0, 0, 0, 0.25) calc(100% - 0.5rem),
      rgba(0, 0, 0, 0) 100%
    );
    background-position: right center;
    position: absolute;
    top: -0.1rem;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
  }
`;

export { RightShadowBorder };
